{
  "save": "Save",
  "common": {
    "yes": "Yes",
    "no": "No",
    "verify": "Verify",
    "okay": "Okay",
    "accept": "Accept",
    "cancel": "Cancel",
    "notAvailable": "Not available"
  },
  "generalInfo": {
    "tab": "General Information",
    "tabMobile": "General",
    "srText": "Account Settings - General Info",
    "name": {
      "label": "Name",
      "pageTitle": "Edit name",
      "firstName": "First name",
      "firstNameError": "Please provide your first name.",
      "lastName": "Last name",
      "lastNameError": "Please provide your last name.",
      "cta": "@:accountSettings.save",
      "successToast": "Name updated."
    },
    "email": {
      "label": "Email",
      "pageTitle": "Edit email",
      "cta": "@:accountSettings.save",
      "helperText": "A verification email will be sent to you.",
      "successToast": "Verification email sent.",
      "noEmailError": "Please provide your email.",
      "invalidEmailError": "Please provide a valid email.",
      "sameEmailError": "The new email address must be different from your current email address.",
      "unavailableError": "This email address is already in use.",
      "verify": {
        "successTitle": "Verifying Email Address",
        "emailVerified": "Your email address has been successfully updated to:",
        "emailVerifiedLogin": "Sign in using the new email address to begin communicating.",
        "signIn": "Sign in",
        "errorTitle": "Verification Error",
        "errorMsg": "This activation link was not found. This email address may have already been verified/activated."
      },
      "modal": {
        "title": "Verify your new email address",
        "lineOne": "We've sent a verification email to {email}.",
        "lineTwo": "Follow the instructions to confirm your new email address, then use it to sign in to TalkingParents.",
        "submit": "Okay"
      }
    },
    "timezone": {
      "label": "Time zone",
      "secondaryLabel": "Date format",
      "combinedLabel": "Time zone/date format",
      "pageTitle": "Edit time zone/date format",
      "cta": "@:accountSettings.save",
      "successToast": "Time zone/date format updated."
    },
    "language": {
      "label": "Language",
      "en": "English",
      "es": "Español"
    },
    "phoneNumber": {
      "label": "Mobile phone number",
      "pageTitle": "Edit mobile phone number",
      "verified": "Verified",
      "unverified": "Unverified",
      "empty": "No mobile phone number provided",
      "description": "Your mobile phone number must be verified to make and receive recorded phone calls. TalkingParents does not share this information with your co-parent.",
      "hintText": "We will text you a temporary code.",
      "removeNumberCta": "remove",
      "cta": "Send code",
      "removeModal": {
        "button": "remove",
        "title": "Remove mobile phone number",
        "content": "Removing your mobile phone number will turn off multi-factor authentication. Are you sure you want to continue?",
        "modalCta": "Yes, remove this phone number",
        "successToast": "Mobile phone number removed."
      },
      "modal": {
        "title": "Verify mobile phone number",
        "description": "Enter the 6-digit code we sent to {0} below to verify your mobile phone number.",
        "cta": "@:accountSettings.common.verify",
        "sendAnotherCode": "@:accountSettings.generalInfo.mfa.modal.sendAnotherCode",
        "resentText": "Verification code sent to {phoneNumber}",
        "successVerifyToast": "Mobile phone number verified.",
        "successUpdateToast": "Mobile phone number updated.",
        "errors": {
          "expiredCode": "This code has expired. Please try again with a new code.",
          "incorrectCode": "Incorrect verification code. Check your phone number or try sending another code in 30 seconds.",
          "tooManyAttempts": "You may only submit one code every 30 seconds. Please try again in 30 seconds.",
          "unexpected": "An unexpected error has occurred. Please contact support for further assistance."
        }
      },
      "errors": {
        "invalid": "Please provide a valid mobile phone number.",
        "tooManyAttempts": "Too many attempts. Try again later or contact support for further assistance."
      }
    },
    "mfa": {
      "label": "Multi-factor authentication",
      "enable": "Enable",
      "description": "Secure your account with text message based multi-factor authentication.",
      "modal": {
        "title": "Enable multi-factor authentication",
        "description": "Enter the 6-digit code we sent to {0}",
        "cta": "Verify",
        "sendAnotherCode": "send another code",
        "resentText": "Verification code sent to {phoneNumber}",
        "helpText": "Not seeing it? Visit our {0}",
        "helpCenter": "Help Center"
      },
      "errors": {
        "phoneNotVerified": "Phone number must be verified before enabling multi-factor authentication.",
        "tooManyAttempts": "Too many attempts. Try again later or contact support for further assistance.",
        "alreadyEnabled": "Multi-factor authentication is already enabled with the phone number associated with your account.",
        "alreadyDisabled": "Multi-factor authentication is already disabled."
      },
      "enabledToast": "Multi-factor authentication enabled.",
      "disabledToast": "Multi-factor authentication disabled."
    },
    "matchedLabel": "Matched",
    "matchedYes": "Yes",
    "matchedNo": "No",
    "coParentLabel": "Co-parent",
    "matchedOnLabel": "Matched on",
    "accountCreatedLabel": "Account Created"
  },
  "planDetails": {
    "tab": "Plan Details",
    "tabMobile": "Plan",
    "label": "Plan type",
    "loadingPlan": "Loading plan...",
    "subscriptionType": {
      "storeSub": "{name} Subscription",
      "complimentary": "Complimentary",
      "pfcComplimentary": "Complimentary Plan"
    },
    "upgradePlan": "Upgrade plan",
    "upgradeOnly": "Upgrade",
    "switchPlan": "Switch plan",
    "managePlan": "Manage plan",
    "startFreeTrial": "Start 30-day free trial",
    "upgradeToStandard": "Upgrade to Standard",
    "upgradeToPremium": "Upgrade to Premium",
    "upgradeTo": "Upgrade to {planName}",
    "tryForFree": "Try {planName} for free",
    "getPlanForPrice": "Get the {planName} for {planPrice}/month. Cancel anytime.",
    "freeTrialForTier": "Free for 30 days for new subscribers, then {planPrice}/month. Cancel anytime.",
    "seeComparison": "See full price comparison",
    "billingInfoHeader": "Billing info",
    "billingTypeLabel": "Billing type",
    "billingTypes": {
      "monthly": "Monthly",
      "annual": "Annual",
      "feeWaiver": "Fee Waiver",
      "promo": "Promo",
      "pfcPromo": "12-month promo"
    },
    "billingNextLabel": "Next billing date",
    "currentPlanExpiresLabel": "Current plan expires",
    "expirationDateLabel": "Expiration date",
    "promotionExpiresLabel": "Promotion expires on",
    "notAvailable": "Not available",
    "feeWaiverNotice": "Fee waiver applied. Reapply before this date to keep your access from expiring. To reapply, contact support.",
    "promoNotice": "Promotional offer applied. Your plan will renew at the standard annual rate.",
    "pfcPromoNotice": "Promotional offer applied. After plan expires, you will need to resubscribe.",
    "promoPurchasedNotice": "Your current plan is active until {expirationDate}. Your promotional period will begin automatically when your current plan expires. After 12 months, your plan renews at the standard rate.",
    "cancel": "Cancel date",
    "successToast": "Plan updated.",
    "tiers": {
      "free": "Free",
      "basic": "Essentials",
      "enhanced": "Enhanced",
      "standard": "Standard",
      "ultimate": "Ultimate",
      "premium": "Premium",
      "unknown": "Unknown",
      "essentials": "Essentials"
    },
    "planName": {
      "free": "Free Plan",
      "basic": "Essentials Plan",
      "enhanced": "Enhanced Plan",
      "standard": "Standard Plan",
      "ultimate": "Ultimate Plan",
      "premium": "Premium Plan",
      "unknown": "Unknown"
    },
    "multiSubModal": {
      "title": "Multiple active subscriptions",
      "subList": "You have multiple active subscriptions through:",
      "cancelText": "Cancel one of your subscriptions to avoid duplicate charges.",
      "tpSub": "By maintaining your subscription through the TalkingParents website, we can better support and assist you with billing management."
    },
    "existingSubscriptionModal": {
      "title": "Existing active subscription",
      "content": "Your account already has an active subscription through TalkingParents. Please contact support for further assistance.",
      "cta": "Okay"
    },
    "appleSubModal": {
      "title": "Apple subscription",
      "content": "You upgraded your account through the Apple App Store. Apple does not allow TalkingParents to manage user subscriptions or in-app purchases. Please visit the Apple App Store to manage your subscription or contact Apple support for more information.",
      "cta": "Okay"
    },
    "androidSubModal": {
      "title": "Google Play subscription",
      "content": "You upgraded your account through the Google Play Store. Google does not allow TalkingParents to manage user subscriptions or in-app purchases. Please visit the Google Play Store to manage your subscription or contact Google support for more information.",
      "cta": "Okay"
    },
    "premiumConfirmModal": {
      "title": "Get the most out of Premium",
      "content": "To get the most out of our Premium Plan with Accountable Calling{0}, both you and your co-parent need to verify your phone number and enable phone and/or video calling in your account settings. These settings can be updated at any time. We will never share your phone number with your co-parent.",
      "cta": "I understand, upgrade my account",
      "cancelCta": "Nevermind"
    },
    "complimentaryPlanModal": {
      "title": "Unable to modify plan",
      "content": "You have a promotion applied to your account. To make changes to your plan, please contact support.",
      "cta": "Contact support"
    },
    "promoPurchasedModal": {
      "title": "Unable to modify plan",
      "content": "You have a promotion applied to your account. To make changes to your plan, please contact support.",
      "cta": "Contact support"
    },
    "subscriptionMigrationModal": {
      "title": "Unable to manage plan",
      "content": "You have a subscription that is scheduled to cancel due to our payment processor migration and will not be able to manage your subscription until the migration is complete.",
      "cta": "Contact support"
    },
    "card": {
      "perAccount": "One free Premium or Standard trial per account.",
      "currentPlan": "Current Plan",
      "freeTrial": "30-day free trial",
      "premium": {
        "access": "Website + mobile app access",
        "priceTagline": "per subscription",
        "bullets": [
          "All Standard and Free features plus:",
          "Make recorded phone and video calls",
          "Send and receive payments",
          "120 calling minutes per month",
          "Access to calling transcripts and recordings"
        ]
      },
      "standard": {
        "access": "@:accountSettings.planDetails.card.premium.access",
        "priceTagline": "@:accountSettings.planDetails.card.premium.priceTagline",
        "bullets": [
          "All Free features plus:",
          "Mobile app access",
          "Create Info Library cards",
          "Receive recorded video calls",
          "Receive video voicemails",
          "Access to unlimited PDF Records",
          "Store and share files in the Vault"
        ]
      },
      "free": {
        "access": "Website access only",
        "priceTagline": "Yes, really. It's free.",
        "bullets": [
          "Send and receive messages",
          "Create shared calendar events",
          "Receive payments",
          "Receive recorded phone calls",
          "and more... "
        ]
      }
    },
    "freeRecord": {
      "pdfHeader": "Free PDF Record",
      "printedHeader": "Full Records Package",
      "statusLabel": "Status",
      "statusAvailable": "Available",
      "redeemedOnLabel": "Redeemed on",
      "nextAvailableLabel": "Next available",
      "statusUnavailable": "Unavailable"
    },
    "payForCoparent": {
      "cta": "Pay for your co-parent's plan",
      "learnMore": "Learn more",
      "helpCenter": "@:accountSettings.planDetails.payForCoparent.learnMore",
      "openRedeemModalCta": "My co-parent paid for my plan",
      "pendingEntitlementNotice": "Your current plan is active until {expirationDate}. Your promotional period will begin automatically when your current plan expires. After 12 months, you will need to resubscribe.",
      "expiresLabel": "Expires",
      "grantedEntitlementNotice": "Your promotional plan is active until {expirationDate}. After 12 months, you will need to resubscribe.",
      "redeemSuccessToast": "Plan updated successfully",
      "reviewModal": {
        "title": "Review your co-parent’s access",
        "intro": "Confirm the details below before continuing to payment.",
        "planValue": "{price} for 12 months",
        "content": "After payment, we’ll email {coParentName} with instructions for activating their access. They will have {offerExpirationDays} days to redeem their plan. Your TalkingParents plan will not change.",
        "cancelCta": "Cancel",
        "continueCta": "Continue to payment"
      },
      "redeemModal": {
        "title": "Your co-parent paid for a year of {tier} access.",
        "titleMobile": "Your co-parent paid for your plan.",
        "intro": "For your account matched with {coParentName}.",
        "availableAccess": "Available access",
        "monthsIncluded": "months included",
        "content": "No credit card or payment required. Redeem before {expirationDate}. Plan includes 12 months of access to {tier}. Any changes to this plan must be made by contacting support. At the end of 12 months, this subscription will end and you will need to subscribe to a new plan.",
        "learnMore": "@:accountSettings.planDetails.payForCoparent.learnMore",
        "redeemCta": "Redeem plan"
      },
      "confirmModal": {
        "title": "Confirm your new plan",
        "content": "You're about to start 12 months of {tier}, paid for by your co-parent. You won't be able to make changes to your subscription once it's active.",
        "scheduledContent": "You won't be able to make changes to your plan once it's active. Visit our Help Center to learn more about redeeming a plan paid for by your co-parent.",
        "goBack": "Go back",
        "confirmCta": "Confirm plan",
        "learnMore": "@:accountSettings.planDetails.payForCoparent.learnMore",
        "contactSupport": "Contact support"
      },
      "activePlanModal": {
        "title": "You're already on an active plan",
        "intro": "You can redeem this plan once you cancel your current plan.",
        "content": "Your new plan will become active once your previous plan expires. If you're on another promotional or complimentary plan and want to make changes to your subscription, you will need to contact support. If you signed up through another app store like Apple or Google Play, you will need to cancel through that store.",
        "managePlan": "Manage plan",
        "learnMore": "@:accountSettings.planDetails.payForCoparent.learnMore",
        "contactSupport": "Contact support"
      },
      "success": {
        "title": "Purchase successful",
        "content": "Thank you for your purchase. Your co-parent will receive an email with instructions for activating their subscription.",
        "cta": "Done"
      },
      "error": {
        "content": "There is an issue with your sponsorship. Please contact support.",
        "entitlementTimeoutContent": "Your plan update is taking longer than expected to apply. Please check back in a few minutes. If your plan still hasn't updated, contact support."
      }
    },
    "paywall": {
      "header": "Manage Plan",
      "fullPricePlans": "Full Price Plans",
      "promoBanner": "{important}: You have a promotion applied to your account. To make changes to your plan, please {contactSupport}.",
      "promoBannerImportant": "Important",
      "promoBannerContactSupport": "contact support",
      "tableHeader": {
        "monthly": "Monthly",
        "annual": "Annual",
        "save": "(Save 8%)"
      },
      "free": {
        "header": "Free",
        "subHeader": "",
        "webOnly": "Web only",
        "bullets": [
          "Ad-supported Secure Messaging",
          "Shared Calendar",
          "Personal Journal",
          "Receive recorded phone calls",
          "Ad-supported",
          "Basic access to most features",
          "In-app purchases required"
        ],
        "monthlyPrice": "0",
        "annualPrice": "0",
        "savingsMonthly": "",
        "savingsAnnual": ""
      },
      "currency": "$",
      "usd": "USD",
      "perMonth": "per month",
      "perYear": "per year",
      "upgradePlan": "Upgrade plan",
      "currentPlan": "Current plan",
      "managePlan": "Manage plan",
      "essentials": {
        "header": "Essentials",
        "subHeader": "Messaging, Calendar, plus:",
        "bullets": [
          "{minutes} calling minutes",
          "1 GB Vault File Storage"
        ],
        "monthlyPrice": "6",
        "annualPrice": "60",
        "savingsMonthly": "Save {currency}7 with Annual plans",
        "savingsAnnual": "{currency}7 annual savings"
      },
      "enhanced": {
        "header": "Enhanced",
        "subHeader": "All of Essentials features plus:",
        "bullets": [
          "{minutes} calling minutes",
          "Unlimited PDF Records",
          "15 GB Vault file storage"
        ],
        "monthlyPrice": "12",
        "annualPrice": "120",
        "savingsMonthly": "Save {currency}16 with Annual plans",
        "savingsAnnual": "{currency}16 annual savings"
      },
      "ultimate": {
        "header": "Ultimate",
        "subHeader": "All of Enhanced features plus:",
        "bullets": [
          "Unlimited calling minutes",
          "Sentiment Scanner + Writing Assist℠",
          "Priority help desk support",
          "Express pay",
          "50 GB Vault file storage"
        ],
        "monthlyPrice": "27",
        "annualPrice": "270",
        "savingsMonthly": "Save {currency}32 with Annual plans",
        "savingsAnnual": "{currency}32 annual savings"
      },
      "seeFullPricingPlan": "Need help deciding? See full {pricingPlan} for more options.",
      "pricingPlan": "pricing plan",
      "promo": {
        "titlePrice1": "[Promo Card Title If The Title Is Long ]",
        "bullet1Price1": "Full {tier} plan access",
        "bullet2Price1": "12 months billed {upfront}",
        "bullet2UpfrontPrice1": "upfront",
        "bullet3Price1": "No interruption to {yourAccount}",
        "bullet3YourAccountPrice1": "your account",
        "titlePrice2": "[Second promo]",
        "bullet1Price2": "[Foo]",
        "bullet2Price2": "[Bar]",
        "bullet3Price2": "[Baz]",
        "cta": "Get 12-Month Offer",
        "disclaimer": "Renews at standard pricing after promotional period"
      },
      "discountedOfferTitle": "Discounted Offer",
      "limitedTimeOfferLabel": "Limited Time Offer",
      "limitedTimeOfferDetailFree": "Offer only available until June 1st, 2026, paid upfront. Billed as a one-time 12-month charge. After 12 months, your plan renews at the standard annual rate.",
      "limitedTimeOfferDetailPaid": "Offer only available until June 1st, 2026, paid upfront. Promotional period begins after your existing plan expires. Billed as a one-time 12-month charge. After 12 months, your plan renews at the standard annual rate.",
      "fullPricePlansLabel": "Full Price Plans",
      "promoCard": {
        "cta": "Lock in my offer",
        "planOnly": "{planName} Plan",
        "planForPrice": "{planName} Plan for {price}",
        "discountAvailable": "Discount available for {planName} plan",
        "discounts": {
          "price1": {
            "essentials": "16% discount off Essentials monthly pricing / 9% discount off Essentials annual pricing",
            "enhanced": "16% discount off Enhanced monthly pricing / 9% discount off Enhanced annual pricing",
            "ultimate": "16% discount off Ultimate monthly pricing / 9% discount off Ultimate annual pricing"
          },
          "price2": {
            "essentials": "14% discount off Essentials monthly pricing / 6% discount off Essentials annual pricing",
            "enhanced": "25% discount off Enhanced monthly pricing / 18% discount off Enhanced annual pricing",
            "ultimate": "15% discount off Ultimate monthly pricing / 7% discount off Ultimate annual pricing"
          }
        }
      }
    },
    "duplicateSubscriptionModal": {
      "title": "Existing active subscription",
      "content": "Your account already has an active subscription through TalkingParents. Please contact support for further assistance."
    },
    "promotionExpiresOnLabel": "Promotion expires on",
    "newPlanStartsLabel": "New plan starts",
    "promoPurchasedExplanation": "Your current plan is active until {date}. Your promotional period will begin automatically when your current plan expires. After 12 months, your plan renews at the standard rate."
  },
  "calling": {
    "tab": "Accountable Calling",
    "tabMobile": "Calling"
  },
  "notifications": {
    "tab": "Notifications",
    "email": {
      "label": "Email notifications",
      "description": "Get an email when you receive a new message, calendar event, or Info Library card.",
      "disabledSuccessToast": "Email notifications disabled.",
      "enabledSuccessToast": "Email notifications enabled."
    },
    "text": {
      "label": "Text notifications",
      "description": "Receive text notifications for new messages.",
      "remainingBalance": "Remaining balance",
      "disabledSuccessToast": "Text notifications disabled.",
      "enabledSuccessToast": "Text notifications enabled.",
      "disableModal": {
        "title": "Disable text message notifications",
        "content": "Please confirm that you want to disable receiving text message notifications and refund your remaining prepaid balance.",
        "confirmCta": "Okay",
        "cancelCta": "Cancel"
      },
      "unverifiedModal": {
        "title": "Unverified number",
        "content": "Please verify your mobile phone number before enabling text message notifications.",
        "confirmCta": "Okay"
      },
      "enterVerificationCode": "Enter Verification Code",
      "enableTitle": "Enable Text Notifications",
      "checkoutRedirectError": "There was an error with re-directing you to the checkout page. Please try again."
    },
    "newsletter": {
      "label": "Email newsletters",
      "description": "Stay informed with the latest feature news and parenting resources.",
      "cta": "Edit preferences"
    }
  },
  "password": {
    "tab": "Password",
    "srText": "Account Settings - Update Password",
    "current": {
      "label": "Current password",
      "emptyError": "Current password is required.",
      "incorrectError": "Current password is incorrect."
    },
    "new": {
      "label": "New password",
      "emptyError": "New password is required.",
      "requirementsError": "Password does not meet the requirements.",
      "sameError": "New password cannot be the same as your current password."
    },
    "confirm": {
      "label": "Confirm new password",
      "emptyError": "Confirm new password is required.",
      "noMatchError": "Passwords do not match."
    },
    "successToast": "Password updated.",
    "update": "Update"
  },
  "links": {
    "tos": "Terms of service",
    "privacyPolicy": "Privacy Policy"
  },
  "messaging": {
    "tab": "Secure Messaging",
    "tabMobile": "Messaging",
    "toggle": {
      "label": "Suggest calendar events",
      "description": "Automatically create events from your messages for you to review and add to your Shared Calendar."
    },
    "sentimentToggle": {
      "label": "Show sentiment (Private)",
      "description": "Shows your Sentiment Score on scanned messages in your conversation. This is only visible to you and will not appear in your record."
    },
    "paymentRequestToggle": {
      "label": "Suggest payment requests",
      "description": "Allow AI to detect and suggest Accountable Payments requests from your messages.",
      "enabled": "Suggested payment requests enabled.",
      "disabled": "Suggested payment requests disabled."
    },
    "errors": {
      "updatePaymentRequestSuggestions": "Failed to update payment request suggestions setting",
      "updateSentiment": "An error has occurred: {error}"
    }
  },
  "calendar": {
    "tab": "Shared Calendar",
    "tabMobile": "Calendar",
    "header": "Connect to Personal Calendar",
    "description": "Automatically add Shared Calendar events to your personal calendar. Only viewed events are added. Changes to these events in your personal calendar will not be reflected in TalkingParents.",
    "learnMore": "Learn more",
    "provider": {
      "connectCta": "Connect",
      "disconnected": "Calendar disconnected. Click to reconnect.",
      "deleted": "Calendar disconnected. Click to reconnect.",
      "updated": "Last updated {datetime}",
      "toast": {
        "connected": "{providerName} connected.",
        "successTitle": "Success"
      },
      "modal": {
        "connect": {
          "header": "\"TalkingParents\" wants to use \"{providerName}\" to sign in",
          "content": "TalkingParents needs permission to add Shared Calendar events to your personal calendar.",
          "confirmCta": "Continue",
          "cancelCta": "Cancel"
        },
        "trash": {
          "header": "Remove connected calendar?",
          "content": "This will remove access to your personal calendar and new Shared Calendar events will no longer be added.",
          "confirmCta": "Continue",
          "cancelCta": "Cancel"
        },
        "scopes": {
          "header": "Permissions required",
          "content": "To connect your calendar with TalkingParents, you must grant all requested permissions. Try connecting again and accept both permission requests. Visit the Help Center for more information.",
          "confirmCta": "Try again",
          "cancelCta": "Cancel"
        },
        "disconnected": {
          "header": "Calendar disconnected",
          "content": "TalkingParents is no longer connected to your personal calendar. New events won’t be added until you reconnect.",
          "confirmCta": "Reconnect",
          "cancelCta": "Not now"
        },
        "deleted": {
          "header": "Calendar disconnected",
          "content": "TalkingParents has been disconnected from your personal calendar. Visit the Help Center for common fixes and troubleshooting steps.",
          "confirmCta": "Help center",
          "cancelCta": "Not now"
        },
        "connectIssue": {
          "header": "Calendar connection issue",
          "content": "TalkingParents cannot connect to your personal calendar. Visit the Help Center for common fixes and troubleshooting steps.",
          "confirmCta": "Help center",
          "cancelCta": "Dismiss"
        }
      },
      "errors": {
        "initializeGoogleAuth": "Unable to initialize authentication with Google.",
        "connectGoogle": "TalkingParents failed to connect to Google.",
        "manualSync": "Failed to manually sync calendar.",
        "disconnect": "Failed to disconnect calendar."
      }
    }
  },
  "appearance": {
    "tab": "Appearance",
    "srText": "Appearance"
  },
  "minutesPlan": {
    "minutes": "Minutes",
    "selected": "Selected",
    "select": "Select"
  }
}
